import React, { useState } from 'react';
import { MyRefundsContainer } from './styled';

function NeedHelp(props) {
  const { needHelpClickHandler } = props;
  const [lowOpacity, setLowOpacity] = useState('');
  return (
    <MyRefundsContainer
      className={lowOpacity}
      onClick={(e) => {
        setLowOpacity('lowOpacity');
        setTimeout(() => {
          needHelpClickHandler(e);
        }, 100);
        setTimeout(() => {
          setLowOpacity('');
        }, 2000);
      }}
    >
      <p>Need Help</p>
      <img
        src="https://images.myloapp.in/NestJsUploads/1728644959351-need-support.svg"
        alt=""
      />
    </MyRefundsContainer>
  );
}

export default NeedHelp;
